export const GET_EXAM_ROOMS = "GET_EXAM_ROOMS"
export const GET_EXAM_ROOMS_FAIL = "GET_EXAM_ROOMS_FAIL"
export const GET_EXAM_ROOMS_SUCCESS = "GET_EXAM_ROOMS_SUCCESS"

export const ADD_NEW_EXAM_ROOM = "ADD_NEW_EXAM_ROOM"
export const ADD_EXAM_ROOM_SUCCESS = "ADD_EXAM_ROOM_SUCCESS"
export const ADD_EXAM_ROOM_FAIL = "ADD_EXAM_ROOM_FAIL"

export const UPDATE_EXAM_ROOM = "UPDATE_EXAM_ROOM"
export const UPDATE_EXAM_ROOM_SUCCESS = "UPDATE_EXAM_ROOM_SUCCESS"
export const UPDATE_EXAM_ROOM_FAIL = "UPDATE_EXAM_ROOM_FAIL"

export const DELETE_EXAM_ROOM = "DELETE_EXAM_ROOM"
export const DELETE_EXAM_ROOM_SUCCESS = "DELETE_EXAM_ROOM_SUCCESS"
export const DELETE_EXAM_ROOM_FAIL = "DELETE_EXAM_ROOM_FAIL"

export const RESET_EXAM_ROOM_LAST_ACTION_SUCCESS = "RESET_EXAM_ROOM_LAST_ACTION_SUCCESS";



// Disponibilité
export const CHECK_EXAM_ROOM_AVAILABILITY = "CHECK_EXAM_ROOM_AVAILABILITY";
export const CHECK_EXAM_ROOM_AVAILABILITY_SUCCESS = "CHECK_EXAM_ROOM_AVAILABILITY_SUCCESS";
export const CHECK_EXAM_ROOM_AVAILABILITY_FAIL = "CHECK_EXAM_ROOM_AVAILABILITY_FAIL";

